import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import AuthLayout from "@/ui/components/auth/AuthLayout";
import RegisterForm from "@/ui/components/auth/RegisterForm";
import { supabase } from "@/infra/supabase/client";
import { Loader2 } from "lucide-react";

export default function Register() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [prefilledEmail, setPrefilledEmail] = useState<string | undefined>();
  const [loading, setLoading] = useState(!!token);
  const [tokenError, setTokenError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;

    const lookupToken = async () => {
      const { data, error } = await supabase
        .from("pre_registrations")
        .select("email, is_used, expires_at")
        .eq("access_token", token)
        .maybeSingle();

      if (error || !data) {
        setTokenError("Convite inválido ou não encontrado.");
        setLoading(false);
        return;
      }

      if (data.is_used) {
        setTokenError("Este convite já foi utilizado.");
        setLoading(false);
        return;
      }

      if (data.expires_at && new Date(data.expires_at) < new Date()) {
        setTokenError("Este convite expirou. Solicite um novo convite.");
        setLoading(false);
        return;
      }

      setPrefilledEmail(data.email);
      setLoading(false);
    };

    lookupToken();
  }, [token]);

  if (loading) {
    return (
      <AuthLayout title="Verificando convite..." subtitle="Aguarde um momento">
        <div className="flex justify-center py-12">
          <Loader2 className="w-8 h-8 animate-spin text-accent-800" />
        </div>
      </AuthLayout>
    );
  }

  if (tokenError) {
    return (
      <AuthLayout title="Convite inválido" subtitle={tokenError}>
        <div className="text-center py-4">
          <a
            href="/login"
            className="text-accent-800 hover:text-accent-700 font-medium text-sm transition-colors"
          >
            Voltar ao login
          </a>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Crie sua conta"
      subtitle="Junte-se aos profissionais que transformam conhecimento em resultados"
    >
      <RegisterForm prefilledEmail={prefilledEmail} />
    </AuthLayout>
  );
}
